import ApiEndpointConstants from '../constants/api/ApiEndpointConstants';
import api from './API';

export const uploadImg = (file) => {
    return api.post(
        `${ApiEndpointConstants.UPLOAD}`,
        { file },
    );
}